import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import React, { useRef } from 'react';
import { ErrorMessage } from './AddressPopup.styles';
import Loading from '@/common/components/Loading';
import { ADDRESS_FORCE_SAVE_VALIDATION_CALLS } from '../constants/addressForceSaveValidationCalls';
import InputsEE from './components/inputsEE/InputsEE';
import InputsBG from './components/inputsBG/InputsBG';
import InputsSK from './components/inputsSK/InputsSK';
import InputsHR from './components/inputsHR/InputsHR';
import InputsHU from './components/inputsHU/InputsHU';

const INPUTS_PER_COUNTRY = {
	sk: InputsSK,
	ee: InputsEE,
	bg: InputsBG,
	hr: InputsHR,
	hu: InputsHU,
};

const AddressPopup = ({ contact, hook }) => {
	const { translation } = useTranslationContext();
	const {
		handleSubmitAddressForm,
		addressFormInputs,
		handleChangeInputValue,
		validationCalls,
		isSaved,
		errorRef,
	} = hook;

	const SelectedInputs = INPUTS_PER_COUNTRY[contact?.country];

	return (
		<PopUp setShow={hook.setIsAddressPopupOpen}>
			<div ref={errorRef}>
				{hook.validationMessage && (
					<ErrorMessage>{hook.validationMessage}</ErrorMessage>
				)}
			</div>
			{hook.isLoading && <Loading />}
			<form
				style={{
					display: 'flex',
					alignItems: 'center',
					flexDirection: 'column',
					gap: '12px',
				}}
			>
				{SelectedInputs && (
					<SelectedInputs
						handleChangeInputValue={handleChangeInputValue}
						addressFormInputs={addressFormInputs}
					/>
				)}
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						gap: '30px',
						width: '100%',
					}}
				>
					{!hook.isLoading &&
						(isSaved ? (
							<SubmitButton
								color={Colors.lightGreen}
								text={translation.saved}
								onClick={(e) => e.preventDefault()}
							/>
						) : validationCalls >= ADDRESS_FORCE_SAVE_VALIDATION_CALLS ? (
							<SubmitButton
								color={Colors.red2}
								text={`!!! ${translation.save}`}
								onClick={(e) => handleSubmitAddressForm(e, contact._id, true)}
							/>
						) : (
							<SubmitButton
								color={Colors.blue}
								text={translation.save}
								onClick={(e) => handleSubmitAddressForm(e, contact._id, false)}
							/>
						))}
				</div>
			</form>
		</PopUp>
	);
};

export default AddressPopup;
